import React from "react";
import Input, { InputAdornment } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Paper from "material-ui/Paper";

export const styles = theme => ({
  button: {
    border: "1px #3f51b5 solid",
    borderRadius: "5px",
    marginTop: "10px",
    alignSelf: "flex-end"
  },
  container: {
    flexGrow: 1,
    position: "relative"
  },
  suggestionsContainerOpen: {
    position: "absolute",
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    left: 0,
    right: 0,
    zIndex: 10
  },
  suggestion: {
    display: "block"
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  textField: {
    width: "100%"
  },
  input: {
    alignSelf: "center",
    padding: 0,
    height: "auto"
  }
});

export const renderInput = inputProps => {
  const {
    classes,
    autoFocus,
    value,
    ref,
    error,
    onKeyPress,
    onFocus,
    icon,
    endAdornment,
    ...other
  } = inputProps;

  return (
    <Input
      className={classes.textField}
      margin="dense"
      autoFocus={autoFocus}
      onFocus={onFocus}
      onKeyPress={onKeyPress}
      error={error.departure}
      fullWidth
      id="departure"
      type="text"
      value={value}
      inputRef={ref}
      inputProps={{
        ...other
      }}
      startAdornment={
        <InputAdornment position="start">
          <div className="input-icon-container">
            <img alt="departure" src={icon} />
          </div>
        </InputAdornment>
      }
      endAdornment={endAdornment}
    />
  );
};

export const renderSuggestion = (suggestion, { isHighlighted }) => (
  <MenuItem selected={isHighlighted} component="div">
    <div>
      <span style={{ fontWeight: 300 }}>{suggestion.place_name}</span>
    </div>
  </MenuItem>
);

export const renderSuggestionsContainer = options => (
  <Paper {...options.containerProps} square>
    {options.children}
  </Paper>
);

export const getSuggestionValue = suggestion => suggestion;



// WEBPACK FOOTER //
// ./src/containers/MainCard/TabsCard/autocompleteHelper.jsx